module.exports = __webpack_public_path__ + "static/media/event_approval_status_black.a0428392.svg";